import React, { useState } from 'react'
import { DataTable } from './DataTable'
import { FilterConfigs } from './FilterConfigs'
import { GenerateFile } from './GenerateFile'
import { FilterViews } from './FilterViews'
import AppShell from '../../../../Components/AppShell'
import PageHeader from '../../../../Components/PageHeader'

const DataGathering = () => {
  const [isAltered, setIsAltered] = useState(false)

  const handleAlterCallBack = () => {
    setIsAltered((prevstate) => !prevstate)
  }

  return (
    <AppShell>
      <PageHeader
        kicker="Pricing"
        title="Data gathering"
        subtitle="Configure filters and generate brand data files."
        crumbs={[
          { label: 'Home', to: '/home' },
          { label: 'Pricing', to: '/pricing-tools' },
          { label: 'Data Gathering' },
        ]}
      />
      <div className="nx-panel mb-4 flex flex-wrap items-center gap-3 p-4">
        <GenerateFile handleAlterCallBack={handleAlterCallBack} isAltereds={isAltered} />
        <FilterConfigs handleAlterCallBack={handleAlterCallBack} />
        <FilterViews isAltereds={isAltered} />
      </div>
      <div className="nx-panel overflow-hidden p-2 sm:p-4">
        <DataTable isAltereds={isAltered} />
      </div>
    </AppShell>
  )
}

export default DataGathering
